<template>
    <div>
        <!-- Snackbar -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <!-- Quick Links Card -->
        <div id="quick_link_slider">
            <v-row dense>
                <v-col cols="12" sm="10" class="pt-0 d-flex align-center">
                    <v-img src="https://cdn-icons-png.flaticon.com/512/4299/4299106.png" max-width="16" contain
                        ></v-img>
                    <span class="quick-links-title">Quick Links</span>
                </v-col>
                <v-col cols="12" sm="2" align="right" class="d-flex justify-end align-end pr-0 pt-0">
                    <v-btn fab dark x-small color="brand" @click="openDialog">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </v-col>
            </v-row>

            <!-- Quick Links Grid -->
             <template v-if="loadingQuickLinks">
                        <v-row>
                            <v-col v-for="n in 4" :key="n" cols="6">
                                <v-skeleton-loader
                                    type="image"
                                    width="110"
                                    height="110"
                                    style="border-radius: 16px;"
                                />
                            </v-col>
                        </v-row>
                    </template>
            <div v-else class="quick-links-container">
                <div class="quick-link-wrapper" v-for="(qlink, index) in visibleLinks" :key="qlink.id" @click="handleQuickLinkClick(qlink)">
                    <v-hover v-slot="{ hover }">
                        <div class="quick-link-card" :style="{
                            backgroundColor: getCardColor(index),
                            border: `3px solid ${getDarkerBorderColor(index)}`
                        }" :class="{ 'quick-link-hover': hover }">
                            <!-- Delete Button (won't trigger router-link) -->
                            <!-- <v-btn icon small class="delete-btn" @click.stop="deleteQuickLink(qlink)">
                                <v-icon small class="delete-icon">mdi-delete</v-icon>
                            </v-btn> -->

                            <!-- Make icon and text wrapped in router-link only -->
                            <router-link :to="{ name: qlink.link }" class="text-center router-link-area"
                                style="text-decoration: none;">
                                <div class="icon-wrapper">
                                    <v-img :src="qlink.icon" max-width="25" max-height="25" />
                                </div>
                                <div class="quick-link-text">{{ qlink.name }}</div>
                            </router-link>
                        </div>
                    </v-hover>
                </div>
            </div>


            <!-- More / Less Toggle -->
            <div class="text-center mt-2" v-if="quicklinkslist.length > 4">
                <div class="text-center mt-4" v-if="quicklinkslist.length > 4">
                    <v-btn small class="view-toggle-btn" color="brand" variant="elevated"
                        @click="showMore = !showMore">
                        {{ showMore ? 'View Less' : 'View More' }}
                    </v-btn>
                </div>

            </div>

        </div>

        <!-- Add Quick Link Dialog -->
        <v-dialog v-model="dialog" width="700">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Add Quick Link
                    <v-spacer></v-spacer>
                    <v-btn plain text @click="cancelDialog">Close</v-btn>
                </v-card-title>

                <v-card-text v-if="all_role_links">
                    <v-row>
                        <v-col cols="12" md="10" sm="12">
                            <v-combobox v-model="add_link" :items="all_role_links" item-text="linkname" item-value="id"
                                label="Add Quick Links" return-object multiple chips clearable />                       
                        </v-col>
                        <v-col cols="12" md="2" sm="2"  class="d-flex text-center align-center justify-center">                             
                             <v-btn color="primary" @click="saveQuickLinks">Add</v-btn>
                        </v-col>                        
                    </v-row>

                    <!-- Existing Quick Links with Delete Button -->
                    <v-row>
                        <v-col cols="12" v-if="quicklinkslist.length">
                            <div class="pa-2" style="border: 1px solid #ccc; border-radius: 8px;">
                                <strong>Existing Quick Links:</strong>
                                <v-list dense>
                                    <v-list-item v-for="ql in quicklinkslist" :key="ql.id">
                                        <v-list-item-content>{{ ql.name }}</v-list-item-content>
                                        <v-list-item-action>
                                            <v-avatar size="32" color="red" class="d-flex align-center justify-center"
                                                @click.stop="deleteQuickLink(ql)" style="cursor: pointer;">
                                                <v-icon small style="color: white;">mdi-delete</v-icon>
                                            </v-avatar>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>


<script>
import axios from "axios";

export default {
    data() {
        return {
            dialog: false,
            showMore: false,
            snackbar: false,
            snackbar_msg: "",
            color: "",
            quick_links: [],
            quicklinkslist: [],
            all_role_links: [],
            add_link: [],
            cardColors: [
                "#f3e8ff", "#e6f9d6", "#ffe6e6",
                "#d4f0fc", "#fff3cd", "#e0f7fa"
            ],
            loadingQuickLinks: true,
        };
    },
    computed: {
        visibleLinks() {
            return this.showMore ? this.quicklinkslist : this.quicklinkslist.slice(0, 4);
        }
    },
    mounted() {
        this.getquicklinks();
        fetch("https://api.ipify.org?format=json")
            .then(x => x.json())
            .then(({ ip }) => localStorage.setItem("myip", ip));
    },
    methods: {
        handleQuickLinkClick(link) {
            sessionStorage.removeItem("para_role_type")
            sessionStorage.setItem("para_role",link.name)
            sessionStorage.setItem("is_quick_link","true")
       },
        getCardColor(index) {
            return this.cardColors[index % this.cardColors.length];
        },
        getDarkerBorderColor(index) {
            const hex = this.getCardColor(index).replace("#", "");
            const amt = -40; // Decrease brightness

            let R = parseInt(hex.substring(0, 2), 16);
            let G = parseInt(hex.substring(2, 4), 16);
            let B = parseInt(hex.substring(4, 6), 16);

            // clamp between 0-255
            R = Math.max(0, Math.min(255, R + amt));
            G = Math.max(0, Math.min(255, G + amt));
            B = Math.max(0, Math.min(255, B + amt));

            return `rgb(${R}, ${G}, ${B})`;
        },
        openDialog() {
            this.dialog = true;
        },
        cancelDialog() {
            this.dialog = false;
            this.sliderCloseOpen(true);
            this.add_link = [];
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        sliderCloseOpen(val) {
            const quickslidediv = document.getElementById("quick_link_slider");
            quickslidediv.style.right = val ? "-280px" : "0px";
        },
        deleteQuickLink(qlink) {
            axios.post("roleManagement/deleteQuickLinks", { qlinkid: qlink.id })
                .then(res => {
                    if (res.data.msg === "200") {
                        this.quicklinkslist = res.data.quick_links;
                        this.all_role_links = res.data.all_role_links;
                        this.showSnackbar("success", "Link deleted successfully...");
                    }
                });
        },
        saveQuickLinks() {
            if (!this.add_link.length) {
                this.showSnackbar("#b71c1c", "Please select");
                return;
            }
            axios.post("roleManagement/saveQuickLinks", this.add_link)
                .then(res => {
                    if (res.data.msg === "200") {
                        this.quicklinkslist = res.data.quick_links;
                        this.all_role_links = res.data.all_role_links;
                        this.dialog = false;
                        this.sliderCloseOpen(false);
                        this.showSnackbar("#4caf50", "Quick Link added successfully...");
                        this.add_link = [];
                    }
                });
        },
        getquicklinks() {
            this.loadingQuickLinks = true;
            let uid = localStorage.getItem("EPS-uid");
            if (uid !== "admin@eps.com") {
                axios.post("roleManagement/getUserRoleLinks")
                    .then(res => {
                        if (res.data.msg === "200") {
                            this.quicklinkslist = res.data.quick_links;
                            this.all_role_links = res.data.all_role_links;
                        }
                    })
                    .finally(() => {
                        this.loadingQuickLinks = false;
                    });
            } else {
                this.quick_links = this.$store.state.quick_links;
                this.loadingQuickLinks = false;
            }
        }
    }
};
</script>
<style scoped>
.quick-links-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    /* padding: 10px 0px; */
    gap: 15px;
    /* background-color: white; */
    border-radius: 20px;
}

.quick-link-wrapper {
    flex: 0 1 38%;
    /* 2 cards per row with wrap */
    display: flex;
    justify-content: center;
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .quick-link-wrapper {
    flex: 0 1 22%; /* 4 cards per row with small spacing */
  }
}

.quick-link-card {
    border-radius: 18px;
    width: 120px;
    height: 120px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: box-shadow 0.3s ease;
    /* box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.1); */
    position: relative;
}

.router-link-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
}

.quick-link-hover {
    box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.25);
}

.delete-btn {
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 1;
    padding: 2px;
    background-color: white;
    border-radius: 50%;
}

.view-toggle-btn {
    border-radius: 20px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: none;
    padding: 6px 18px;
    font-size: 14px;
    background-color: #1e88e5;
    /* primary blue */
    color: white;
    /* box-shadow: 0 2px 4px rgba(30, 136, 229, 0.4); */
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.view-toggle-btn:hover {
    background-color: #1565c0;
    box-shadow: 0 4px 10px rgba(21, 101, 192, 0.4);
}


.icon-wrapper {
    background-color: white;
    border-radius: 50%;
    padding: 8px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.quick-link-text {
    font-size: 14px;
    font-weight: 600;
    color: #1e293b;
}

.quick-links-title {
    font-size: 18px;
    font-family: Georgia, 'Times New Roman', Times, serif;
    font-weight: 600;
    color: #1e293b;
    padding-left: 10px;
}

.theme--light.v-icon {
    color: orange;
}

@media print {
    .no-display {
        display: none !important;
    }
}
</style>
